import { ApiContext } from '../../types'
import { AuthHelper } from '@/api_client'
import { deserializeCreditUsage } from '@/api_client/api/serializers/credit_usage'

export default async function getCreditUsages(
  { client, config }: ApiContext,
  params = {},
) {
  const response = await client.creditUsages.list(
    AuthHelper.getAccessToken(),
    params,
  )
  if (response.isSuccess()) {
    const success = response.success()
    const data = success.data
    const meta = success.meta

    // num_pages:1
    // per_page:20
    // total_count:0
    return {
      data: data.map((item: any) => deserializeCreditUsage(item)),
      meta: meta,
    }
  } else {
    console.log('getUsers: fail')
    throw response.fail()
  }
}
